import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from "@angular/core";

import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { ActivatedRoute } from "@angular/router";
import { IRONFLY_TECHNOLOGIES } from "../models/constants/global.constants";
@Component({
  selector: "app-frontend-layout",
  templateUrl: "frontend-layout.component.html",
})
export class FrontendLayoutComponent implements OnInit, OnDestroy {
  protected text = "";
  protected version: string;
  protected year = "2025";
  protected hasMaxWidth = true;
  protected IRONFLY_TECHNOLOGIES = IRONFLY_TECHNOLOGIES;

  private platformUtilsService: PlatformUtilsService = inject(PlatformUtilsService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  async ngOnInit() {
    this.year = new Date().getFullYear().toString();
    this.version = await this.platformUtilsService.getApplicationVersion();
    document.body.classList.add("layout_frontend");
  }

  onActivate() {
    this.text = this.route.snapshot.firstChild?.data["text"];
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    document.body.classList.remove("layout_frontend");
  }
}
